import { serviceTypesBuilder, ServiceTypesModel } from "shared/models/ServiceTypes";
import { httpTrafficLights } from "../http/httpClient";

export const serviceTypesService = () => {
  const getAll = async (
    page: number | null,
    page_size: number | null,
    sort: string | null,
    dir: string | null,
  ): Promise<ServiceTypesModel> => {
    const params = new URLSearchParams();
    if (page !== null) params.append('page', String(page));
    if (page_size !== null) params.append('page_size', String(page_size));
    if (sort !== null) params.append('sort', String(sort));
    if (dir !== null) params.append('dir', String(dir));
    const res = await httpTrafficLights.get(`service-types?${params.toString()}`);
    return {
    ...res,
      rows: res.rows.map(serviceTypesBuilder.fromBackEnd)
    };
  };

  return {
    getAll
  };
};